define('src/controller/layout-controller',[
    // Libs
    'underscore', 'backbone', 'utils',
    // Views | Layout
    'views/layouts/layout-body',
    'views/layouts/layout-app',
], function(
    // Libs
    _, Backbone, U,
    // layout
    VLayoutBody,
    VLayoutApp
) {
    /**
     * The layout controller creates, renders and owns the only
     * instance of VLayoutBody.
     */
    var body = new VLayoutBody();

    var LayoutController = function(opt) {
        this.options = _.extend({
            getLayoutInstance: 'getLayoutInstance',
        }, opt);

        this.view = {};
        this.view.layout = this.options.layout;
    };

    _.extend(LayoutController.prototype, Backbone.Events, {

        getLayout: function() {
            // lazy create the layout the first time
            var options = this.options,
                view = this.view,
                layoutView = view.layout,
                oldLayout = body.getContent();

            if (!layoutView || oldLayout !== layoutView) {
                layoutView = view.layout = _.callback(options.context || this, options.getLayoutInstance);
                this.trigger('layout:created', layoutView);
            }

            body.setContent(layoutView);

            if (oldLayout !== layoutView) this.trigger('layout:switch', oldLayout, layoutView);

            return layoutView;
        },

        setMain: function(view) {
            this.view.layout.getContent().setView(view);
        },

        // default layout
        getLayoutInstance: function() {
            return new VLayoutApp();
        },
    });

    LayoutController.extend = Backbone.Router.extend;

    body.render();

    return LayoutController;
});

